"use client"

import { Container, Box } from "@mui/material"
import {
  GitBranch,
  LayoutDashboard,
  Stethoscope,
  ShieldCheck,
  Pill,
  Brain,
} from "lucide-react"

const steps = [
  {
    id: 1,
    title: "Post Office Claims Transaction",
    description:
      "Seamless connectivity and structured data exchange between healthcare providers and payer comply with regulator mandates.",
    icon: GitBranch,
    color: "#1976d2",
  },
  {
    id: 2,
    title: "Tracking & Dashboard",
    description:
      "Track, monitor, and visualize the entire claim lifecycle with real-time insights and analytics.",
    icon: LayoutDashboard,
    color: "#42a5f5",
  },
  {
    id: 3,
    title: "Medical & Coding Scrubber",
    description:
      "Detect medical and coding denials swiftly for accurate claim validation and compliance.",
    icon: Stethoscope,
    color: "#2196f3",
  },
  {
    id: 4,
    title: "Control Claim Validation",
    description:
      "Configure relations and optimize your claim validation process to meet specific requirements while maintaining compliance.",
    icon: ShieldCheck,
    color: "#4caf50",
  },
  {
    id: 5,
    title: "Pharmaceutical Claims Management",
    description:
      "Leverage our Built-In Pharmaceutical Edits and Checks Suite to streamline your workflow and reduce denials in medication-related claims.",
    icon: Pill,
    color: "#ff9800",
  },
  {
    id: 6,
    title: "AI Module",
    description:
      "Better understand behaviours of all entities and improve data-driven decision-making with trend insights.",
    icon: Brain,
    color: "#9c27b0",
  },
]

const HowItWork = () => {
  return (
    // أضفنا mt-24 وأنقصنا الـ pt شوي لتوازن السكشن
    <div
      className="benefits-container bg-gradient-to-r from-[#020817] via-[#041E2F] to-[#000000] mt-24 pt-10"
      data-aos="fade-up"
      data-aos-duration="1000"
    >
      {/* خلفيات دوائر */}
      <div className="benefits-bg-elements">
        <div className="floating-circle circle-1"></div>
        <div className="floating-circle circle-2"></div>
        <div className="floating-circle circle-3"></div>
        <div className="floating-orb orb-1"></div>
        <div className="floating-orb orb-2"></div>
        <div className="floating-orb orb-3"></div>
      </div>

      <Container maxWidth={false} sx={{ maxWidth: "full", mx: "auto" }}>
        {/* العنوان */}
        <Box className="benefits-header">
          <h2 className="benefits-title">Multi-Layer Claim Cycle Solutions</h2>
          <p className="benefits-subtitle">
            Streamline your healthcare claims processing with our comprehensive suite of intelligent solutions
          </p>
        </Box>

        {/* الكروت */}
        <div className="benefits-grid">
          {steps.map((step, index) => {
            const IconComponent = step.icon
            return (
              <div
                className="benefit-card"
                key={step.id}
                style={{
                  "--color": step.color,
                  "--delay": `${index * 0.1}s`,
                  background: "rgba(255, 255, 255, 0.04)",
                  backdropFilter: "blur(14px)",
                  WebkitBackdropFilter: "blur(14px)",
                  border: "1px solid rgba(255, 255, 255, 0.1)",
                  borderRadius: "18px",
                  padding: "32px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "14px",
                }}
              >
                <div className="benefit-icon-container top-left" style={{ marginBottom: "0" }}>
                  <span
                    className="icon-glow small"
                    style={{
                      background: step.color,
                      borderRadius: "50%",
                      position: "absolute",
                      top: "0",
                      left: "0",
                      transform: "translate(-50%, -50%)",
                      width: "36px",
                      height: "36px",
                    }}
                  ></span>

                  <span
                    className="benefit-icon small with-circle"
                    style={{
                      color: step.color,
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: "10",
                    }}
                  >
                    <IconComponent size={22} />
                  </span>
                </div>

                <div className="benefit-content">
                  <h3
                    className="benefit-title compact"
                    style={{
                      color: "#ffffff",
                      fontWeight: "600",
                      fontSize: "1.25rem",
                      marginBottom: "8px",
                      textShadow: "0 2px 10px rgba(0,0,0,0.4)",
                    }}
                  >
                    {step.title}
                  </h3>

                  <p
                    className="benefit-description compact"
                    style={{
                      color: "rgba(255, 255, 255, 0.92)",
                      lineHeight: "1.6",
                      fontSize: "0.95rem",
                      margin: 0,
                      textShadow: "0 1px 8px rgba(0,0,0,0.5)",
                    }}
                  >
                    {step.description}
                  </p>
                </div>

                <div
                  className="benefit-number"
                  style={{
                    fontSize: "3.5rem",
                    opacity: "0.03",
                  }}
                >
                  {String(step.id).padStart(2, "0")}
                </div>
              </div>
            )
          })}
        </div>
      </Container>
    </div>
  )
}

export default HowItWork
